module.exports = "https://www.gc-qa.gnp.com.mx/db5148b47b205e90ac28f8b3afbd88c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-share.png
// module id = 8130
// module chunks = 0